import { haversine } from './model';

// stations (m) along measured profile points + height range
export function profileData(profile = []) {
  let st = 0;
  const pts = profile.map((p, i) => {
    if (i) st += haversine([profile[i - 1].lat, profile[i - 1].lon], [p.lat, p.lon]);
    return { ...p, st, depth: p.ground != null && p.pipe != null ? p.ground - p.pipe : null };
  });
  const hs = pts.flatMap((p) => [p.ground, p.pipe]).filter((v) => v != null);
  if (pts.length < 2 || !hs.length) return null;
  const lo = Math.min(...hs), hi = Math.max(...hs), pad = Math.max(0.2, (hi - lo) * 0.15);
  return { pts, len: st, min: lo - pad, max: hi + pad };
}
